import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { isDefined, _cs } from '@togglecorp/fujs';
import { genericMemo } from '../../../utils/index.js';
import styles from './styles.css.js';

function TableHeader(props) {
  const {
    className,
    children,
    onResize,
    onResizeComplete,
    name,
    ...otherProps
  } = props;
  const elementRef = React.useRef(null);
  const mouseDownXOnResizeHandleRef = React.useRef();
  const headingWidthRef = React.useRef();
  const finalHeadingWidthRef = React.useRef();
  const handleMouseMove = React.useCallback(e => {
    if (isDefined(mouseDownXOnResizeHandleRef.current) && elementRef.current && onResize) {
      e.preventDefault();
      e.stopPropagation();
      const dx = e.clientX - mouseDownXOnResizeHandleRef.current;

      if (isDefined(headingWidthRef.current)) {
        const newWidth = headingWidthRef.current + dx;
        finalHeadingWidthRef.current = newWidth;
        onResize(newWidth, name);
      } else {
        var _elementRef$current;

        headingWidthRef.current = (_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.offsetWidth;
      }
    }
  }, [onResize, name]);
  const handleResizeHandleMouseDown = React.useCallback(e => {
    var _elementRef$current2;

    mouseDownXOnResizeHandleRef.current = e.clientX;
    headingWidthRef.current = (_elementRef$current2 = elementRef.current) === null || _elementRef$current2 === void 0 ? void 0 : _elementRef$current2.offsetWidth;
    window.addEventListener('mousemove', handleMouseMove, true);
  }, [handleMouseMove]);
  React.useEffect(() => {
    const handleMouseUp = () => {
      mouseDownXOnResizeHandleRef.current = undefined;
      headingWidthRef.current = undefined;

      if (onResizeComplete && isDefined(finalHeadingWidthRef.current)) {
        onResizeComplete(finalHeadingWidthRef.current, name);
      }

      window.removeEventListener('mousemove', handleMouseMove, true);
    };

    window.addEventListener('mouseup', handleMouseUp, true);
    return () => {
      window.removeEventListener('mouseup', handleMouseUp, true);
      window.removeEventListener('mousemove', handleMouseMove, true);
    };
  }, [handleMouseMove, name, onResizeComplete]);
  return /*#__PURE__*/React.createElement("th", _extends({
    ref: elementRef,
    className: _cs(className, styles.th)
  }, otherProps), onResize && /*#__PURE__*/React.createElement("div", {
    role: "presentation",
    className: styles.resizeHandle,
    onMouseDown: handleResizeHandleMouseDown
  }), children);
}

var TableHeader$1 = genericMemo(TableHeader);

export { TableHeader$1 as default };
//# sourceMappingURL=index.js.map
